import React from "react";
import { Module as ModuleProd } from "../IDMS";

// If ModuleProd takes no props:
export const Module: React.FC = () => <ModuleProd />;

// If ModuleProd takes props (unlikely here, but for completeness):
// export const Module: React.FC<SomePropsType> = (props) => <ModuleProd {...props} />;
